import React, { useState, useEffect } from 'react'
import { Modal, Form, Input, Button, message, Row, Col } from 'antd'
import { UserOutlined, MailOutlined, PhoneOutlined, HomeOutlined } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'

const ProfileModal = ({ visible, onClose }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const { user, updateProfile } = useAuth()

  // Reset form when modal opens
  useEffect(() => {
    //console.log('Profile', user);
    if (visible && user) {
      form.setFieldsValue({
        name: user.name,
        email: user.email,
        phone: user.phone,
        address: user.address,
        role: user.role
      })
    }
  }, [visible, user, form])

  const handleSubmit = async (values) => {
    setLoading(true)
    
    try {
      const result = await updateProfile(values)
      
      if (result.success) {
        onClose()
        form.resetFields()
      }
    } catch (error) {
      console.error('Profile update error:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title="แก้ไขโปรไฟล์"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        size="large"
        requiredMark={false}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="name"
              label="ชื่อ"
              rules={[
                {
                  required: true,
                  message: 'กรุณาระบุชื่อ'
                }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="ชื่อของคุณ"
              />
            </Form.Item>
          </Col>
          
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label="อีเมล"
              rules={[
                {
                  required: true,
                  message: 'กรุณาระบุอีเมล'
                },
                {
                  type: 'email',
                  message: 'รูปแบบอีเมลไม่ถูกต้อง'
                }
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="อีเมลของคุณ"
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="phone"
          label="เบอร์โทรศัพท์"
          rules={[
            {
              required: true,
              message: 'กรุณาระบุเบอร์โทรศัพท์'
            }
          ]}
        >
          <Input
            prefix={<PhoneOutlined />}
            placeholder="เบอร์โทรศัพท์ของคุณ"
          />
        </Form.Item>

        <Form.Item
          name="address"
          label="ที่อยู่"
          rules={[
            {
              required: true,
              message: 'กรุณาระบุที่อยู่'
            }
          ]}
        >
          <Input.TextArea
            prefix={<HomeOutlined />}
            placeholder="ที่อยู่ของคุณ"
            rows={3}
          />
        </Form.Item>

        {/* Role display */}
        {user?.role && (
          <Form.Item label="ตำแหน่ง">
            <Input
              value={user.role}
              disabled
              style={{ backgroundColor: '#f5f5f5' }}
            />
          </Form.Item>
        )}

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            ยกเลิก
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            บันทึก
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ProfileModal